import { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ChatInterface } from "@/components/chat/ChatInterface";

export const FloatingChat = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleServiceRequest = (request: string) => {
    // fallback to search
    setOpen(false);
    const q = encodeURIComponent(request);
    navigate(`/?q=${q}`);
  };

  const handleNavigateCompany = (companyId: string) => {
    // Apri pagina azienda invece del checkout
    setOpen(false);
    navigate(`/company/${companyId}`);
  };

  return (
    <>
      <Button
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 rounded-full h-12 w-12 shadow-strong"
        aria-label="Apri assistente"
      >
        <MessageCircle className="h-5 w-5" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="p-0 overflow-hidden max-w-lg">
          <ChatInterface 
            onServiceRequest={handleServiceRequest} 
            onNavigateCompany={handleNavigateCompany}
            className="h-[520px]" 
            structured 
          />
        </DialogContent>
      </Dialog>
    </>
  );
};


